import { GoalLinksSpec, IGoalLinkSpecDetails } from "@webapp/okrs/goals/models/goal-links.models";
import { IMetricLinkSpecDetails, MetricLinksSpec } from "@webapp/okrs/metrics/models/metrics-links.models";
import { IOkrLinksExpanded } from "@webapp/okrs/models/okrs-links.models";

export class Links<T extends LinkSpecDetail> {
  public expanded?: IOkrLinksExpanded;
  public spec: ItemLinksSpec<T>;
}

export class LinksDTO<T extends Link> {
  public sourceId: string;
  public sourceType: LinkSourceTargetType;
  public targetId: string;
  public targetType: LinkSourceTargetType;
  public linkType: T;
}

export enum ExpandedLinkType {
  GOALS = "goals",
  METRICS = "metrics",
}

export type LinkSourceTargetType = "goals" | "metrics";

export type SourceType = "goal" | "metric";

export type BulkLink = Pick<LinksDTO<Link>, "sourceType" | "sourceId">;

export enum CascadingKRLinks {
  CASCADING = "cascading",
  CONTRIBUTING = "contributing",
}

export type GoalLink = "supporting";
export type CascadingLink = "cascading";
export type RelatedLink = "supporting" | "supported" | "blocking" | "blocked" | "preceding" | "preceded" | "relating" | "related" | "cascading" | "contributing";
// TODO: Merge GoalLink & RelatedLink when A12 Related Items is released
export type Link = RelatedLink;

export type ItemLinksSpec<T extends LinkSpecDetail> = T extends MetricLinksSpec ? IMetricLinkSpecDetails : T extends GoalLinksSpec ? IGoalLinkSpecDetails : never;

export type LinkSpecDetail = GoalLinksSpec | MetricLinksSpec;

export interface ILinksSpecDetail<T extends LinkSpecDetail> {
  id: string;
  type: T;
  dateCreated?: string;
}

export interface ICanLinkInfoRecord {
  canLink?: boolean;
  reason?: string;
}

export interface ICanLinkInfo {
  canLinkInfo: {
    [K in CascadingLink]: {
      [targetId: string]: ICanLinkInfoRecord;
    };
  };
}
